export default __webpack_public_path__ + "89657bca5105c70a54518486b91777b1.svg";